<template>
  <div>
    <div class="tw-flex tw-flex-wrap"> 
      <div class="tw-mb-10 tw-w-1/2 tw-pr-8">
        <div class="tw-pt-4 tw-outline tw-outline-0 tw-relative tw-border-b-2 focus-within:tw-border-orange-medium">
          <input 
            v-model="state.firstName"
            type="text" 
            name="firstName" 
            placeholder=" "
            :disabled="props.disabled"
            @keyup="firstNameSet"
            class="tw-block tw-text-2xl tw-py-4 tw-w-full tw-border-0 tw-appearance-none focus:tw-outline-0 tw-bg-transparent tw-border-transparent focus:tw-border-transparent focus:tw-ring-0 tw-px-0" />
          <label for="email" class="tw-pointer-events-none tw-absolute tw-top-0 tw-py-4 tw--z-1 tw-duration-300 tw-origin-top-left">First Name</label>
        </div>
      </div>

      <div class="tw-mb-10 tw-w-1/2 tw-pl-8">
        <div class="tw-pt-4 tw-outline tw-outline-0 tw-relative tw-border-b-2 focus-within:tw-border-orange-medium">
          <input 
            v-model="state.lastName"
            type="text" 
            name="lastName" 
            placeholder=" "
            :disabled="props.disabled"
            @keyup="lastNameSet"
            class="tw-block tw-text-2xl tw-py-4 tw-w-full tw-border-0 tw-appearance-none focus:tw-outline-0 tw-bg-transparent tw-border-transparent focus:tw-border-transparent focus:tw-ring-0 tw-px-0" />
          <label for="email" class="tw-pointer-events-none tw-absolute tw-top-0 tw-py-4 tw--z-1 tw-duration-300 tw-origin-top-left">Last Name</label>
        </div>
      </div>

      <div class="tw-mb-10 tw-w-1/2 tw-pr-8">
        <div class="tw-pt-4 tw-outline tw-outline-0 tw-relative tw-border-b-2 focus-within:tw-border-orange-medium">
          <input 
            v-model="state.emailAddress"
            type="text" 
            name="email" 
            placeholder=" "
            :disabled="props.disabled"
            @keyup="emailAddressSet"
            class="tw-block tw-text-2xl tw-py-4 tw-w-full tw-border-0 tw-appearance-none focus:tw-outline-0 tw-bg-transparent tw-border-transparent focus:tw-border-transparent focus:tw-ring-0 tw-px-0" />
          <label for="email" class="tw-pointer-events-none tw-absolute tw-top-0 tw-py-4 tw--z-1 tw-duration-300 tw-origin-top-left">Email Address</label>
        </div>
      </div>

      <div class="tw-mb-10 tw-w-1/2 tw-pl-8">
        <div class="tw-pt-4 tw-outline tw-outline-0 tw-relative tw-border-b-2 focus-within:tw-border-orange-medium">
          <input 
            v-model="state.phoneNumber"
            type="text" 
            name="phoneNumber" 
            placeholder=" "
            :disabled="props.disabled"
            @keyup="phoneNumberSet"
            class="tw-block tw-text-2xl tw-py-4 tw-w-full tw-border-0 tw-appearance-none focus:tw-outline-0 tw-bg-transparent tw-border-transparent focus:tw-border-transparent focus:tw-ring-0 tw-px-0" />
          <label for="email" class="tw-pointer-events-none tw-absolute tw-top-0 tw-py-4 tw--z-1 tw-duration-300 tw-origin-top-left">Phone Number</label>
        </div>
      </div>
    </div>

    <div class="tw-mb-10">
      <div class="tw-pt-4 tw-outline tw-outline-0 tw-relative tw-border-b-2 focus-within:tw-border-orange-medium">
        <input 
          v-model="state.contact"
          type="text" 
          name="pickupContact" 
          placeholder=" "
          @keyup="contactSet"
          class="tw-block tw-text-2xl tw-py-4 tw-w-full tw-border-0 tw-appearance-none focus:tw-outline-0 tw-bg-transparent tw-border-transparent focus:tw-border-transparent focus:tw-ring-0 tw-px-0" />
        <label for="email" class="tw-pointer-events-none tw-absolute tw-top-0 tw-py-4 tw--z-1 tw-duration-300 tw-origin-top-left">Order Pickup Contact (optional)</label>
      </div>
      <div class="tw-text-lg tw-mt-4">
        <template v-if="props.deliverymode && props.deliverymode == 'delivery'">
          Who is receiving this order?
        </template>
        <template v-else>
          Who is picking up this order?
        </template>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import {
    reactive, computed, onMounted, ref, watch
  } from 'vue';

  const props = defineProps<{ 
    firstName: string,
    lastName: string,
    emailAddress: string,
    phoneNumber: string,
    contact: string,
    deliverymode: string,
    disabled: boolean,
  }>();

  const state = reactive({
    firstName: '',
    lastName: '',
    emailAddress: '',
    phoneNumber: '',
    contact: '',
    initialized: false,
  })

  const emit = defineEmits(['setFirstName', 'setLastName', 'setEmailAddress', 'setPhoneNumber', 'setContact'])

  onMounted(() => {
    if (props.firstName) {
      state.firstName = props.firstName;
    } 

    if (props.lastName) {
      state.lastName = props.lastName;
    }

    if (props.emailAddress) {
      state.emailAddress = props.emailAddress;
    }

    if (props.phoneNumber) {
      state.phoneNumber = props.phoneNumber;
    }

    if (props.contact) {
      state.contact = props.contact;
    }
    // After we complete setting initial states
    state.initialized = true;
  })

  const firstNameSet = ((event: Event) => {
    const target = event.target as HTMLInputElement;
    if (state.initialized) {
      emit('setFirstName', target.value)
    }
  })

  const lastNameSet = ((event: Event) => {
    const target = event.target as HTMLInputElement;
    if (state.initialized) {
      emit('setLastName', target.value)
    }
  })

  const emailAddressSet = ((event: Event) => {
    const target = event.target as HTMLInputElement;
    if (state.initialized) {
      emit('setEmailAddress', target.value)
    }
  })

  const phoneNumberSet = ((event: Event) => {
    const target = event.target as HTMLInputElement;
    if (state.initialized) {
      emit('setPhoneNumber', target.value)
    }
  })

  const contactSet = ((event: Event) => {
    const target = event.target as HTMLInputElement;
    emit('setContact', target.value)
  })


</script>